module.exports = __webpack_public_path__ + "images/large-ajax-loader.gif";